/**
 * Check if element is clickable as a link on click event on the block container
 * Caution: add cursor pointer on clickable elements
 * @param {event} e - Click event
 * @param {object} link - true link in the block. (from ref.current added to the link)
 * @param {object} config - object that contains link list that needed to be linked with link href and target
 */
const addLinksToBlockElements = ({ e, config, link }) => {
  const { ctrlKey, metaKey, target } = e;

  if (target.closest(config.css.links.map((item) => `.${item}`).join(', '))) {
    if (link.getAttribute('target') === '_blank' || ctrlKey || metaKey) {
      window.open(link.getAttribute('href'), '_blank', 'noopener=true');
    } else {
      link.click();
    }
  }
};

export default addLinksToBlockElements;
